import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  PM_GATE_DETAIL,
  PM_CHECKLIST,
  ADD_CATEGORY_TYPE,
  CATEGORY_TYPE,
  SUB_CATEGORY_TYPE,
  PM_GATE,
  SCHEDULED_TICKETS,
  ADD_CATEGORY_LIST,
  ENGINEER_LIST,
  PM_PROJECT_CHECKLIST
} from './type';
export const fetchPmGateDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchGatesMaintenanceDetails}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_GATE_DETAIL,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchGatesChecklist = (id, gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchGatesMaintenanceMaterials}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchCategoryType = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchMaintenanceCategoryType}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: ADD_CATEGORY_TYPE,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchCategory = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchMaintenanceCategory}?category_type=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CATEGORY_TYPE,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchSubCategoryType = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchMaintenanceMaterialList}?category_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SUB_CATEGORY_TYPE,
      payload: data.response.data,
    });
    return data.response.data;
  }
};

export const postPmData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.maintenance.postPmData}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const fetchgetSiteGates = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.getSiteGates}?schedule_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_GATE,
      payload: data.response.data,
    });
    return true;
  }
};

export const sendForApproval = (id,otp) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.maintenance.pmSendApproval}?schedule_id=${id}&otp=${otp}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

// export const createMrfForMaintenance = (data) => async () => {
//   const res = await callWebService(
//     callTypes.post,
//     data,
//     `${Config.maintenance.createMrfForMaintenance}`
//   );
//   if (res?.data?.response?.status === true) {
//     return true;
//   } else {
//     return false;
//   }
// };

export const siteSchedule = (id, selectedEngineer) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.siteSchedule}?site_id=${id}&sm_engineer=${selectedEngineer}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const getScheduledTicket = (id, manageId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.scheduledTicket}?site_id=${id}&schedule_id=${manageId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SCHEDULED_TICKETS,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchCategoryList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchCategoryList}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: ADD_CATEGORY_LIST,
      payload: data.response.data,
    });
    return true;
  }
};


export const engineerList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.engineerList}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: ENGINEER_LIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const fetchPmProjectChecklist = (id,schedule_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.maintenance.fetchMaintenancePMForProjects}?site_id=${id}&schedule_id=${schedule_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: PM_PROJECT_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

